import type { WikiEditorState } from "../wiki-types";
import { Input } from "@softmax/design-system";
import { styles } from "../wiki.styles";
import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  colors,
  fonts,
  fontSizes,
  radii,
} from "@softmax/design-system/tokens.stylex";

export function WikiEditorFields({
  editor,
  fieldId,
}: Readonly<{
  editor: WikiEditorState;
  fieldId: string;
}>) {
  return (
    <>
      <label htmlFor={`${fieldId}-title`} {...stylex.props(styles.label)}>
        <span {...stylex.props(styles.fieldTitle)}>Title</span>
        <Input
          required
          id={`${fieldId}-title`}
          readOnly={editor.pending}
          value={editor.draft.title}
          onChange={(event) =>
            editor.onDraftChange({
              ...editor.draft,
              title: event.target.value,
            })
          }
        />
      </label>
      <label {...stylex.props(styles.label)}>
        <span {...stylex.props(styles.fieldTitle)}>Markdown</span>
        <textarea
          required
          readOnly={editor.pending}
          value={editor.draft.body}
          onChange={(event) =>
            editor.onDraftChange({
              ...editor.draft,
              body: event.target.value,
            })
          }
          {...stylex.props(localStyles.textarea)}
        />
      </label>
    </>
  );
}
const localStyles = stylex.create({
  textarea: {
    boxSizing: "border-box",
    width: "100%",
    minHeight: "24rem",
    padding: spacing.space12,
    resize: "vertical",
    borderRadius: radii.medium,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.borderStrong,
    color: colors.foreground,
    backgroundColor: colors.background,
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    fontWeight: 400,
    lineHeight: 1.6,
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 3,
  },
});
